import { render, staticRenderFns } from "./GuangzhouUnicom21.vue?vue&type=template&id=1c4f8a34&scoped=true"
import script from "./GuangzhouUnicom21.vue?vue&type=script&lang=js"
export * from "./GuangzhouUnicom21.vue?vue&type=script&lang=js"
import style0 from "./GuangzhouUnicom21.vue?vue&type=style&index=0&id=1c4f8a34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4f8a34",
  null
  
)

export default component.exports